import {
  CREDITOR_ID_CHARACTER_REGEX,
  SEPA_CHARACTER_REGEX,
  SEPA_CHARACTER_REGEX_ID,
  UMLAUTS_REGEX,
} from "@/scripts/Constants";

const hasSepaCondition = (value: string) => typeof value === 'string' && SEPA_CHARACTER_REGEX.test(value);
const hasSepaConditionForId = (value: string) => typeof value === 'string' && SEPA_CHARACTER_REGEX_ID.test(value);

const hasValidLengthOnSepaCondition = (value: string, maxLength: number) => {
  return typeof value === 'string'
    && value.replace(UMLAUTS_REGEX, 'aa').length <= maxLength;
}

const hasSepaCreditorIdCondition = (value: string) => typeof value === 'string' && CREDITOR_ID_CHARACTER_REGEX.test(value);

export {
  hasSepaCondition,
  hasSepaConditionForId,
  hasValidLengthOnSepaCondition,
  hasSepaCreditorIdCondition
}
